import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Form, Input, Select, Space, Table, Tag } from 'tdesign-react';
import { getTopicAclInfo } from '@/services/kopPermissionsService';
import useTable from '@/hooks/useTable';
import { renderDateTime, toTsOptions } from '@/utils/common';
import { options } from '@/pages/KOPCluster/Permissions/Grant/KOPGrant';

const { FormItem } = Form;

export default function KopACLs({ commonProps }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  const columns = [
    {
      colKey: 'roleName',
      title: 'KopUser',
      width: 120,
    },
    {
      colKey: 'operations',
      title: '操作权限',
      width: 300,
      cell: ({ row }) => (
        <Space size={[4, 2]} breakLine>
          {row?.operations?.map((item) => (
            <Tag key={item}>{item}</Tag>
          ))}
        </Space>
      ),
    },
    {
      colKey: 'resource',
      title: '资源',
    },
    {
      colKey: 'createTime',
      title: '创建时间',
      cell: renderDateTime,
      width: 200,
    },
  ];

  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getTopicAclInfo({ ...params, clusterName, resource: commonProps.topic });
    setData(
      data.map((item) => ({
        ...item,
        operations: item.operations.split(','),
      })),
    );
  });

  const { config, header, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        <FormItem name='principal'>
          <Input placeholder='请输入KopUser' clearable />
        </FormItem>
        <FormItem name='resourceType'>
          <Select options={toTsOptions(options)} placeholder='请选择权限' clearable />
        </FormItem>
      </>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch, clusterName]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 18px;
`;
